var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.744 11.707L8.682 15.769C7.63153 16.8201 7.04099 18.245 7.04 19.731C7.03895 20.4583 7.18141 21.1787 7.45924 21.8509C7.73706 22.5231 8.14479 23.1339 8.65905 23.6482C9.17331 24.1626 9.784 24.5704 10.4561 24.8484C11.1283 25.1263 11.8487 25.2689 12.576 25.268C14.0622 25.2667 15.4871 24.6758 16.538 23.625L20.6 19.563L12.744 11.707Z",
    fill: "#18406E",
    stroke: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.068 10.383L18.129 6.32199C19.1799 5.27115 20.6048 4.68025 22.091 4.67899C22.8182 4.67781 23.5386 4.82016 24.2107 5.09789C24.8828 5.37561 25.4935 5.78326 26.0078 6.29745C26.5221 6.81165 26.9299 7.42229 27.2077 8.09436C27.4856 8.76644 27.628 9.48674 27.627 10.214C27.6259 11.7003 27.0354 13.1255 25.985 14.177L21.923 18.239L14.068 10.383Z",
    fill: "#18406E",
    stroke: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.937 16.386L7.33699 7.446C7.23699 7.437 7.137 7.435 7.037 7.435C5.99825 7.43608 4.98883 7.77957 4.16502 8.4123C3.34121 9.04502 2.74897 9.93168 2.48 10.935C2.19767 11.9872 2.28798 13.1046 2.73563 14.0978C3.18327 15.0909 3.96068 15.8987 4.936 16.384L4.937 16.386Z",
    fill: "#2EA967",
    stroke: "#2EA967"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14399 7.92999L6.74399 16.871C6.84399 16.878 6.94399 16.882 7.04399 16.882C8.10857 16.8813 9.14171 16.521 9.97583 15.8595C10.8099 15.198 11.3961 14.2741 11.6392 13.2377C11.8824 12.2012 11.7682 11.113 11.3153 10.1496C10.8624 9.18615 10.0972 8.404 9.14399 7.92999Z",
    fill: "#2EA967",
    stroke: "#2EA967"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.946,
    height: 29.947,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality);
export default __webpack_public_path__ + "static/media/speciality.e1a3609c603c56b06b0ab5650dc536b3.svg";
export { ForwardRef as ReactComponent };